import {core as tokens} from '../design-tokens';

// This needs to go into the Figma JSON.
// Theo nly tokens that exist here is tokens that are currently complex and we dont have time / infra for them now.

const lgShadow1 = tokens.shadows[`shadow-l-1`];
const lgShadow2 = tokens.shadows[`shadow-l-2`];
const lgShadow = `${lgShadow1.x} ${lgShadow1.y} ${lgShadow1.blur} ${lgShadow1.spread} rgba(0, 0, 0, 0.06), ${lgShadow2.x} ${lgShadow2.y} ${lgShadow2.blur} ${lgShadow2.spread} rgba(0, 0, 0, 0.08)`;
const xlShadow = `0px  16px 24px -4px rgba(0, 0, 0, 0.08), 0px  4px  8px -2px rgba(0, 0, 0, 0.04)`;
const xsShadowTokens = tokens.shadows[`shadow-xs`];
const xsShadow = `${xsShadowTokens.x} ${xsShadowTokens.y} ${xsShadowTokens.blur} ${xsShadowTokens.spread} rgba(0, 0, 0, 0.08)`;

export const core = {
  shadows: {
    [`2.inset`]: `inset 0 0 2px rgba(0,0,0,0.12),inset 0 0px 1px rgba(0,0,0,0.14)`,
    2: `0 0 2px rgba(0,0,0,0.12), 0 0px 1px rgba(0,0,0,0.14)`,
    [`4.inset`]: `inset 0 0 4px rgba(0,0,0,0.12), inset 0 0px 0px rgba(0,0,0,0.14)`,
    [`5`]: `rgba(0, 0, 0, 0.04) 0px 5px 10px`,
    [`modal`]: `0px 0px 1px rgba(45, 55, 72, 0.05),0px 4px 8px rgba(45, 55, 72,  0.1)`,
    4: `0 0 2px rgba(0,0,0,0.12), 0 0px 4px rgba(0,0,0,0.14)`,
    // TODO: replace with tokens from design-tokens (Especially the brand color)
    [`8.brand`]: `rgba(35,181,251,0.5) 0px 8px 36px -8px`,
    [`10.brand`]: `rgba(35,181,251,0.5) 0px 10px 40px -10px`,
    [`md`]: `0 0.125rem 0.25rem -0.0625rem rgba(0,0,0,0.06), 0 0.125rem 0.375rem -0.0625rem rgba(0,0,0,0.08)`,
    [`sm`]: `0 0.0625rem 0.125rem -0rem rgba(0,0,0,0.04), 0 0.0625rem 0.1875rem 0 rgba(0,0,0,0.06)`,
    [`lg`]: lgShadow,
    [`xl`]: xlShadow,
    [`xs`]: xsShadow,
  },
};

export const typography = {
  body: {
    sm: {
      fontSize: `sm`,
      fontWeight: `normal`,
      lineHeight: `2em`,
    },
    xl: {
      fontSize: `xl`,
      fontWeight: `700`,
      lineHeight: `2em`,
    },
  },
};
